import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiMenu, FiUser, FiHome, FiUsers, FiFileText, FiGlobe, FiDollarSign, FiBarChart2, FiSettings, FiX, FiCreditCard } = FiIcons;

const Header = ({ toggleSidebar }) => {
  const [showDropdown, setShowDropdown] = useState(false);

  const navItems = [
    { path: '/', icon: FiHome, label: 'Dashboard' },
    { path: '/agencies', icon: FiUsers, label: 'Agencies' },
    { path: '/articles', icon: FiFileText, label: 'Articles' },
    { path: '/domains', icon: FiGlobe, label: 'Domains' },
    { path: '/earnings', icon: FiDollarSign, label: 'Earnings' },
    { path: '/billing', icon: FiCreditCard, label: 'Billing' },
    { path: '/analytics', icon: FiBarChart2, label: 'Analytics' },
    { path: '/settings', icon: FiSettings, label: 'Settings' }
  ];

  return (
    <motion.header
      initial={{ y: -20, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      className="bg-white shadow-sm border-b border-gray-200 px-6 py-4"
    >
      <div className="flex items-center justify-between">
        <div className="flex items-center">
          <button
            onClick={toggleSidebar}
            className="lg:hidden p-2 rounded-lg hover:bg-gray-100 transition-colors"
          >
            <SafeIcon icon={FiMenu} className="w-6 h-6" />
          </button>
          <Link 
            to="/" 
            className="text-xl font-semibold text-gray-800 ml-4 lg:ml-0 hover:text-primary-600 transition-colors"
          >
            Article Management Dashboard
          </Link>
        </div>

        {/* Desktop Navigation */}
        <div className="hidden md:flex items-center space-x-6">
          {navItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className="flex items-center text-gray-700 hover:text-primary-600 transition-colors"
            >
              <SafeIcon icon={item.icon} className="w-5 h-5 mr-2" />
              <span>{item.label}</span>
            </Link>
          ))}
        </div>

        {/* User Menu */}
        <div className="relative">
          <button
            onClick={() => setShowDropdown(!showDropdown)}
            className="flex items-center space-x-2 p-2 rounded-lg hover:bg-gray-100 transition-colors"
          >
            <div className="w-8 h-8 bg-primary-500 rounded-full flex items-center justify-center">
              <SafeIcon icon={FiUser} className="w-4 h-4 text-white" />
            </div>
            <span className="text-sm font-medium text-gray-700 md:inline hidden">Admin</span>
          </button>

          {/* Mobile Menu Dropdown */}
          {showDropdown && (
            <motion.div
              initial={{ opacity: 0, y: -10 }}
              animate={{ opacity: 1, y: 0 }}
              className="absolute right-0 mt-2 w-56 bg-white rounded-lg shadow-lg py-2 z-50 md:hidden"
            >
              <div className="px-4 py-2 border-b border-gray-100 flex justify-between items-center">
                <span className="font-medium text-gray-800">Navigation</span>
                <button
                  onClick={() => setShowDropdown(false)}
                  className="p-1 rounded-full hover:bg-gray-100"
                >
                  <SafeIcon icon={FiX} className="w-4 h-4" />
                </button>
              </div>
              {navItems.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  className="flex items-center px-4 py-2 text-gray-700 hover:bg-primary-50 hover:text-primary-600"
                  onClick={() => setShowDropdown(false)}
                >
                  <SafeIcon icon={item.icon} className="w-5 h-5 mr-3" />
                  {item.label}
                </Link>
              ))}
            </motion.div>
          )}
        </div>
      </div>
    </motion.header>
  );
};

export default Header;